module.exports = __webpack_public_path__ + "img/Conversational-Commerce.75f918dc.svg";